import React, { useCallback, useState } from 'react'
import { observer } from 'mobx-react'
import { ProductImage, Stepper, BagIcon, Tags, RequiredBadge } from 'components'
import CashierController from '@ctrls/cashierController'
import { cartMobx, restaurantConfig, doProductMobx, productMobx } from 'restaurant'
import { localStore, showMsg } from '@utils'
import { classNames, classnames, format } from '@dt/fe-utils'
import CartPackPicker from '../CartPackPicker'
import { SingleRemarkBar } from '../'
import DiscountTag from '../DiscountTag'
import { buyTogetherMobx } from '@mobxStore'

interface IProps {
  cartItem: IViewCartItem;
  isGiven?: boolean; // 是否赠送
  index?: number;
  onSelect?: () => void;
  onChangePackCnt?: (cnt: number) => void;
  disabled?: boolean;
}

const CartProductItem: React.FC<IProps> = ({ cartItem, index, isGiven, onSelect, onChangePackCnt, disabled }) => {
  const product = productMobx.noToViewProductMap[cartItem.productNo]
  const isRequiredProduct = cartItem.type === 'product' && product?.isRequired
  const requiredMinCnt = cartMobx.getRequiredProductMinCnt(cartItem.productNo, cartItem.cnt, cartItem)
  // const isNeedEllipsis: boolean = !!((cartItem.optionStr).zhLength() > 16 || cartItem.offItems?.[0]?.offTip.zhLength() > 16 || cartItem.offItems.length > 1 || (cartItem.optionStr && cartItem.offItems.length))
  const isNeedEllipsis: boolean = !!((cartItem.optionStr || '').zhLength() > 32)
  const [showDetail, setShowDetail] = useState([])

  const handleShowDetail = (cartItem) => {
    if (cartMobx.needPack) {
      return
    }
    onSelect ? onSelect() : CashierController.showProductDetail(cartItem)
  }

  const handleChangeCnt = useCallback((isAdd: boolean) => {
    if (isAdd) {
      const { productNo, scaleNo, cnt } = cartItem
      if (doProductMobx.checkInvalidByProductNo(productNo, scaleNo, cnt, cnt + 1)) {
        showMsg(i18n.t('productdetail.saleOutTips2'))
        return
      }
      if (doProductMobx.checkCartItemMaxSalesCnt(productNo, 1)) {
        showMsg(i18n.t('productdetail.saleMaxCntModifyTips', { cnt: productMobx.noToViewProductMap?.[productNo]?.maxSalesCnt }))
        return
      }
      const maxSalesCnt = !Config.buyTogetherId ? doProductMobx.checkMaxSalesCnt() : buyTogetherMobx.checkCartItemMaxSalesCnt()
      if (maxSalesCnt) {
        showMsg(i18n.t('productdetail.saleMaxCntModifyTips', { cnt: maxSalesCnt }))
        return
      }
      cartMobx.add(cartItem.pk)
    } else {
      cartMobx.reduce(cartItem.pk)
    }
  }, [cartItem.cnt])

  const handleEditCnt = useCallback((value: number) => {
    const { productNo, scaleNo, cnt } = cartItem
    if (doProductMobx.checkInvalidByProductNo(productNo, scaleNo, cnt, value)) {
      showMsg(i18n.t('productdetail.saleOutTips2'))
      return
    }
    if (doProductMobx.checkCartItemMaxSalesCnt(productNo, value - cnt)) {
      showMsg(i18n.t('productdetail.saleMaxCntModifyTips', { cnt: productMobx.noToViewProductMap?.[productNo]?.maxSalesCnt }))
      return
    }
    const maxSalesCnt = !Config.buyTogetherId ? doProductMobx.checkMaxSalesCnt() : buyTogetherMobx.checkCartItemMaxSalesCnt()
    if (maxSalesCnt) {
      showMsg(i18n.t('productdetail.saleMaxCntModifyTips', { cnt: maxSalesCnt }))
      return
    }
    cartMobx.changeCnt(cartItem.pk, value)
  }, [cartItem.cnt])

  const handleChangePackCnt = (cnt: number) => {
    onChangePackCnt ? onChangePackCnt(cnt) : cartMobx.setCarPackFkeys(cartItem.fkey, cnt)
  }

  const optionModify = (cartItem: IViewCartItem, isNeedEllipsis: boolean) => {
    return (
      <div
        className='option-modify-offItems'
      >
        <div>
          <span>
            {
              showDetail.includes(cartItem.pk) && !cartItem.optionStr
                ? '' : (
                  <span>
                    {
                      cartItem.optionStr || (isNeedEllipsis ? (
                        <>
                          {/* <i className='iconfont icon-zhekou2x'></i>
                          <span>{cartItem.offItems?.[0]?.offTip}</span> */}
                        </>
                      ) : '')
                    }
                  </span>)
            }
            {isNeedEllipsis && !showDetail.includes(cartItem.pk) ? (
              <i
                className='iconfont icon-zhankai2x'
                data-cypid='optionsModifyShow'
                onClick={(e) => {
                  e.stopPropagation()
                  setShowDetail([...showDetail, cartItem.pk])
                }}
              >
              </i>) : null}
          </span>
          {/* {
            cartItem.offItems.map((v, index: number) => {
              return (
                <p className='off-item' key={index}>
                  <i className='iconfont icon-zhekou2x'></i>
                  <span>{v.offTip}</span>
                </p>
              )
            })
          } */}
        </div>
        {
          isNeedEllipsis && showDetail.includes(cartItem.pk) ? (
            <span
              className='item-detail-handle' data-cypid='optionsModifyHide' onClick={(e) => {
                e.stopPropagation()
                setShowDetail(showDetail.filter(v => v !== cartItem.pk))
              }}
            >
              {i18n.t('newCart.hide')}
            </span>
          ) : null
        }
      </div>
    )
  }

  const productGroup = () => {
    return (
      <div className='item-groups'>
        {
          cartItem.productGroups?.map(group => (
            <div key={group.no} className='item-group'>
              {
                group?.productGroupDetails.map(product => {
                  const needEllipsis: boolean = !!((product.optionStr).zhLength() > 16 || product.offItems?.[0]?.offTip.zhLength() > 16 || product.offItems.length > 1 || (product.optionStr && product.offItems.length))
                  return (
                    <div key={product.pk} className='item-group-product'>
                      <div className={`product-name${needEllipsis && !showDetail.includes(product.pk) ? ' need-ellipsis' : ''}`}>
                        <strong>{product.name}</strong>
                        {optionModify(product, needEllipsis)}
                        <div className='product-extra-info'>
                          <Tags datas={[...(product.tags || []), ...(product.allergys || [])]} />
                        </div>
                        {!!cartMobx.needPack && !product.isCanTogo && <span className='disable-togo'>{i18n.t('newCart.productCanNotTogo')}</span>}
                      </div>
                      <div className='product-cnt'>x {product.cnt}</div>
                    </div>
                  )
                })
              }
            </div>
          ))
        }
      </div>
    )
  }

  return (
    <div
      className={classNames('cart-product-item', {
        'disable-togo': cartMobx.needPack && !cartItem.isCanTogo,
        'disable-cart-items': disabled
      })}
      key={cartItem.pk}
    >
      <div className='product-info'>
        <div className='item-detail' data-cypid={`cartItem_pk_${cartItem?.pk}`} onClick={() => !disabled && handleShowDetail(cartItem)}>
          <div className='cart-product-img-wrap'>
            <ProductImage color={!cartItem.pic && restaurantConfig.displayMode === 'waterfall' ? cartItem.productNo : ''} width={64} imgSrc={cartItem.pic} />
            {isRequiredProduct && <RequiredBadge />}
          </div>
          <div className={`product-name${isNeedEllipsis && !showDetail.includes(cartItem.pk) ? ' need-ellipsis' : ''}`}>
            <strong>{!cartMobx.needPack && !!cartItem.isTogo && (restaurantConfig.codeType !== 'brand' || cartMobx.info.eatType === 'dinein') && !disabled && <BagIcon size='small' />}{isGiven ? <span className='given-tag'>{i18n.t('newCart.given')}</span> : ''}{cartItem.name}</strong>
            {optionModify(cartItem, isNeedEllipsis)}
            <div className='product-extra-info'>
              <Tags datas={[...(cartItem.tags || []), ...(cartItem.allergys || [])]} disableSingleSale={!cartItem.isSingleSale} />
            </div>
            {!!cartMobx.needPack && !cartItem.isCanTogo && <span className='disable-togo'>{i18n.t('newCart.productCanNotTogo')}</span>}
          </div>
          {
            !disabled ? (
              <div className='product-price'>
                <div className='price' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(cartItem.actualPrice) }}>
                  {/* {
                    !disabled && (cartItem as any)?.offTip === 'memberPrice' && <img src={VipImg} alt='' />
                  } */}
                </div>
                <div className='item-discount'>
                  {
                    !disabled && <DiscountTag offItems={cartItem.offItems} />
                  }
                </div>
                {/* <del>{format.toPrice(cartItem.totalPrice)}</del> */}
                {cartItem.actualPrice !== cartItem.totalPrice ? <del dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(cartItem.totalPrice) }}></del> : ''}
                {isGiven ? <span className='cnt'>{i18n.t('newCart.givenCnt', { cnt: cartItem.cnt })}</span> : null}
              </div>
            ) : <></>
          }
          {
            disabled ? (
              <div className='item-disable-info'>
                <p>{i18n.t('checkout.disabledReason.soldout')}</p>
              </div>
            ) : <></>
          }
        </div>
        {productGroup()}
        <div className='item-actions'>
          {!cartMobx.needPack ? (
            <div className='item-actions-wrap'>
              {!disabled && <SingleRemarkBar pk={cartItem.pk} remark={cartItem.remark} />}
              {isGiven ? null : !disabled && <Stepper uid={cartItem.pk} min={requiredMinCnt} onEdit={handleEditCnt} cnt={cartItem.cnt} onChange={handleChangeCnt} />}
            </div>
          ) : cartItem.isCanTogo ? (
            <CartPackPicker cnt={cartMobx.cartPackFkeys[cartItem.fkey] || 0} total={cartItem.cnt} showTip={index === 0 && !localStore.get('packed')} onChange={handleChangePackCnt} />
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default observer(CartProductItem)
